import { t } from '@trimble/i18n';
import { JSX, onMount } from 'solid-js';
import { Portal } from 'solid-js/web';
import ConfirmPopup from '../ConfirmPopup/ConfirmPopup';
import { defineSolidConfirmPopup } from '../ConfirmPopup/confirm-popup-wc';
import { BtnClasses } from '../../types/common';

export interface DeleteConfirmationModalProps {
  title: string;
  message: string;
  waiting?: boolean;
  onCancel(): void;
  onConfirm(): void;
  mount?: HTMLElement | undefined;
}

function DeleteConfirmationModal(
  props: DeleteConfirmationModalProps
): JSX.Element {
  onMount(() => {
    defineSolidConfirmPopup();
  });

  return (
    <Portal mount={props.mount}>
      <ConfirmPopup
        show={true}
        waiting={props.waiting}
        title={props.title}
        description={props.message}
        primaryBtnLabel={t('general.delete')}
        primaryBtnClass={BtnClasses.DANGER}
        secondaryBtnLabel={t('general.cancel')}
        secondaryBtnClass={BtnClasses.SECONDARY}
        onClose={props.onCancel}
        onAction={props.onConfirm}
      />
    </Portal>
  );
}

export default DeleteConfirmationModal;
